import { PATH_THANKYOU } from "../../constants/Paths";
import { proceedOrderToServer } from "../../logic/server/OrderFunction";
import { buildOrderPayloadV2 } from "../../logic/server/PayloadBuilder";

// 28/Jun/2024 VE - New Function
//

export const submitNewOrder = async (utils, user, order, cartItems, selectedStore = null) => {
  const { webApp, sessionToken, navigate } = utils;
  try {
    const {
      userId,
      userName,
      agentId,
      routeDetails,
      customerName,
      customerContact,
      customerAddress,
      timeSlot,
      customerComments,
    } = user;

    const {
      isDeliveryWaived,
      discountAmount,
      deliveryCost,
      surchargeCost,
      paymentCost,
      storeTotalCost,
      charges,
    } = order;

    const userDetails = {
      userId: userId,
      userName: userName,
    };

    const postalCodeDetails = {
      address: customerAddress,
      postalCodeDescr: routeDetails.postalcodedescr,
    };

    const featureFlags = {
      isDeliveryWaived,
    };

    const orderCosts = {
      discountAmount: discountAmount,
      deliveryCost: deliveryCost,
      surchargeCost: surchargeCost,
      baseCost: paymentCost,
      storeTotalCost: storeTotalCost,
      charges: charges,
    };

    const customerDetails = {
      orderName: customerName,
      orderPhone: customerContact,
      orderAddress: customerAddress,
      orderComments: customerComments,
    };

    const orderSummary = buildOrderPayloadV2(
      userDetails,
      customerDetails,
      postalCodeDetails,
      featureFlags,
      cartItems,
      timeSlot,
      orderCosts,
      routeDetails,
      agentId
    );

    const result = await proceedOrderToServer(sessionToken, orderSummary, selectedStore);

    // Handle different result scenarios
    if (result && result.success && result.order) {
      
      // Removed partial success handling since user notifications are now critical
      if (false && result.partialSuccess) {
        // Order created but notifications failed - still navigate to success page
        console.warn("Order created with notification issues:", result.notificationStatus);
        
        // Show warning about notification failure but still proceed
        const notificationErrors = result.notificationStatus.errors.map(err => err.message).join(', ');
        alert(`Order Created Successfully!\n\nHowever, some notifications failed: ${notificationErrors}\n\nYour order is confirmed and will be processed.`);
      }
      
      // Navigate to success page for both full and partial success
      navigate(PATH_THANKYOU, {
        replace: true,
      });
      
    } else {
      // Handle failed order creation
      webApp.MainButton.hideProgress(true);
      webApp.BackButton.show();
      
      const errorMessage = result?.error || "Order creation failed. Please try again.";
      const isRetryable = result?.isRetryable !== false; // Default to retryable unless explicitly false
      
      // Enhanced error messages based on error type
      let alertMessage = `Order Failed: ${errorMessage}`;
      if (isRetryable) {
        alertMessage += "\n\nPlease try again by clicking the Pay button.";
      } else {
        alertMessage += "\n\nPlease check your order details and try again.";
      }
      
      alert(alertMessage);
      
      // Don't throw error - let user stay on page and retry
      console.error("Order submission failed:", result);
    }
  } catch (error) {
    console.error("Unexpected error during order submission:", error);
    webApp.MainButton.hideProgress(true);
    webApp.BackButton.show();
    
    // Handle unexpected errors gracefully
    let errorMessage = "An unexpected error occurred while processing your order.";
    
    if (error.message && error.message.includes('network')) {
      errorMessage = "Network error occurred. Please check your connection and try again.";
    } else if (error.message) {
      errorMessage = error.message;
    }
    
    alert(`Order Error: ${errorMessage}\n\nPlease try again by clicking the Pay button.`);
    
    // Don't navigate away - let user retry
  }
};
